import { SVGAssets } from '@business/assets/vectors';
import { Avatar } from '@business/workflows/ComponentUI/Avatar';

interface LeaderCardItemProps {
  leader?: any;
  onRemove?: (leader: any) => void;
  isCountryDetail?: boolean;
}

export const LeaderCardItem: React.FC<LeaderCardItemProps> = ({
  leader,
  onRemove,
  isCountryDetail
}) => {
  return (
    <div className="relative w-full md:w-1/4 xl:w-1/5 p-3 pr-2">
      {!isCountryDetail ? (
        <>
          <SVGAssets.CloseButtonRounded
            className="w-4 h-4 volunteer-close absolute top-2 right-1 cursor-pointer"
            data-testid="close-button"
            onClick={() => onRemove(leader)}
          />
          <div className="bg-white card-shadow rounded-lg flex flex-col items-center p-4 h-24">
            <Avatar
              alt={leader?.first_name}
              imgClassName="rounded-full w-12 h-12 border border-gray-300 mb-2"
              src={leader?.profile?.profile_pic}
              size="h-12 w-12"
              isHeader={true}
            />
            <p
              title={leader?.first_name + ' ' + leader?.last_name}
              className="text-center text-xs color-primary truncate md:w-20 w-full">
              {leader?.first_name} {leader?.last_name}
            </p>
          </div>
        </>
      ) : (
        <div className="flex flex-col items-center">
          <Avatar
            alt={leader?.first_name}
            imgClassName="rounded-full w-12 h-12 border border-gray-300 mb-2"
            src={leader?.profile?.profile_pic}
            size="h-12 w-12"
            isHeader={true}
          />
          <p
            title={leader?.first_name + ' ' + leader?.last_name}
            className={`text-center ${isCountryDetail ? 'text-[var(--na-secondary-color-hover)] text-sm' : 'color-primary text-xs'} md:w-20 w-full truncate`}>
            {leader?.first_name} {leader?.last_name}
          </p>
        </div>
      )}
    </div>
  );
};
